export default __webpack_public_path__ + "static/media/menu.57258d1b.jpg";